import styled         from 'styled-components';
import { colorTheme } from '@styles/muiTheme';

export const ErrorBoundaryWrapper = styled.div`
  gap: 15px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 20px;
  color: ${colorTheme.palette.grey[700]};
`;
